module.exports = __webpack_public_path__ + "static/img/outsourcing.75a9317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outsourcing.png
// module id = aG6f
// module chunks = 0